/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsApiErrorResponseSchema } from "./goodLuck/core/DTOs/apiErrorResponseSchema.ts";
import { goodLuckCoreDTOsRosterResponseSchema } from "./goodLuck/core/DTOs/rosterResponseSchema.ts";
import { z } from "zod/v4";

export const getTeamsInviteTokenPathParamsSchema = z.object({
  token: z.string(),
});

/**
 * @description OK
 */
export const getTeamsInviteToken200Schema = z.lazy(
  () => goodLuckCoreDTOsRosterResponseSchema,
);

/**
 * @description Not Found
 */
export const getTeamsInviteToken404Schema = z.lazy(
  () => goodLuckCoreDTOsApiErrorResponseSchema,
);

/**
 * @description Internal Server Error
 */
export const getTeamsInviteToken500Schema = z.lazy(
  () => goodLuckCoreDTOsApiErrorResponseSchema,
);

export const getTeamsInviteTokenQueryResponseSchema =
  getTeamsInviteToken200Schema;
